import { motion } from "framer-motion";
import { Gauge, Phone, Mail } from "lucide-react";
import { StatusBadge } from "@/components/Header";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-16 pb-8">
        <div className="grid md:grid-cols-3 gap-10 pb-14">
          <div>
            <div className="flex items-center gap-3">
              <span className="grid place-items-center h-10 w-10 border border-white/15 bg-[#131927]">
                <Gauge className="h-5 w-5 text-[#0055FF]" />
              </span>
              <span className="font-display font-extrabold uppercase tracking-tight">
                Speed Shop <span className="text-[#FF2A3B]">Power</span>
              </span>
            </div>
            <p className="mt-4 text-sm text-slate-500 leading-relaxed max-w-xs">
              SC Speed Shop Power SRL · Magazin de piese auto în Timișoara. Stoc real, piese și pe comandă, consultanță după seria de șasiu — la telefon sau pe WhatsApp.
            </p>
            <div className="mt-4"><StatusBadge /></div>
          </div>

          <div>
            <h4 className="text-xs font-mono uppercase tracking-[0.28em] text-slate-500 mb-4">Navigare</h4>
            <ul className="space-y-2.5 text-sm">
              {[
                ["Cere piesa pe WhatsApp", "#whatsapp"],
                ["Recenzii", "#recenzii"],
                ["Program", "#program"],
                ["Contact", "#contact"],
              ].map(([label, href]) => (
                <li key={href}>
                  <button
                    data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-").replace("ă", "a")}`}
                    onClick={() => window.__lenis?.scrollTo(href, { offset: -72, duration: 1.4 })}
                    className="text-slate-400 hover:text-[#FF2A3B] transition-colors"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-mono uppercase tracking-[0.28em] text-slate-500 mb-4">Contact rapid</h4>
            <p className="text-sm text-slate-400">G. Dragalina nr. 27, Timișoara</p>
            <div className="mt-2 flex flex-col gap-1.5">
              <a data-testid="footer-phone-link" href="tel:+40786804728" className="inline-flex items-center gap-2 text-sm font-semibold text-white hover:text-[#FF2A3B] transition-colors">
                <Phone className="h-4 w-4" /> 0786 804 728
              </a>
              <a data-testid="footer-phone-second-link" href="tel:+40786804729" className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-[#FF2A3B] transition-colors">
                <Phone className="h-4 w-4" /> 0786 804 729
              </a>
              <a data-testid="footer-phone-landline-link" href="tel:+40256706396" className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-[#FF2A3B] transition-colors">
                <Phone className="h-4 w-4" /> 0256 706 396
              </a>
              <a data-testid="footer-email-link" href="mailto:speedshopauto@yahoo.com" className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-[#0055FF] transition-colors">
                <Mail className="h-4 w-4" /> speedshopauto@yahoo.com
              </a>
            </div>
            <div className="mt-5 flex gap-3 text-[11px] font-mono uppercase tracking-[0.14em]">
              <a data-testid="footer-anpc-link" href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer" className="border border-white/15 px-3 py-1.5 text-slate-400 hover:border-[#0055FF] hover:text-white transition-colors">ANPC · SAL</a>
              <a data-testid="footer-sol-link" href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="border border-white/15 px-3 py-1.5 text-slate-400 hover:border-[#0055FF] hover:text-white transition-colors">SOL</a>
            </div>
          </div>
        </div>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          data-testid="footer-kinetic-mark"
          className="font-display font-black uppercase tracking-tight text-center leading-none text-[11.5vw] select-none text-stroke opacity-60"
        >
          Speed Shop Power
        </motion.p>

        <div className="mt-10 pt-6 border-t border-white/5 flex flex-wrap items-center justify-between gap-3 text-[11px] text-slate-600">
          <span>© {new Date().getFullYear()} SC Speed Shop Power SRL · Timișoara, România</span>
          <span className="font-mono uppercase tracking-[0.2em]">Piese auto · Dragalina 27</span>
        </div>
      </div>
    </footer>
  );
}
